/** Códigos de erro da qualidade na medição (Fase 19). */
export const QUALITY_ERROR = {
  // ── A checklist (FVS) ──────────────────────────────────────────────────────
  CHECKLIST_NOT_FOUND: 'QUALITY.CHECKLIST_NOT_FOUND',
  CHECKLIST_INACTIVE: 'QUALITY.CHECKLIST_INACTIVE',
  CHECKLIST_NAME_REQUIRED: 'QUALITY.CHECKLIST_NAME_REQUIRED',
  CHECKLIST_NAME_TOO_LONG: 'QUALITY.CHECKLIST_NAME_TOO_LONG',
  CHECKLIST_NAME_TAKEN: 'QUALITY.CHECKLIST_NAME_TAKEN',
  CHECKLIST_WITHOUT_ITEMS: 'QUALITY.CHECKLIST_WITHOUT_ITEMS',
  CHECKLIST_TOO_MANY_ITEMS: 'QUALITY.CHECKLIST_TOO_MANY_ITEMS',
  CHECKLIST_TOO_MANY_SERVICES: 'QUALITY.CHECKLIST_TOO_MANY_SERVICES',
  CHECKLIST_SAMPLING_INVALID: 'QUALITY.CHECKLIST_SAMPLING_INVALID',
  ITEM_LABEL_TOO_LONG: 'QUALITY.ITEM_LABEL_TOO_LONG',
  ITEM_METHOD_TOO_LONG: 'QUALITY.ITEM_METHOD_TOO_LONG',
  ITEM_TOLERANCE_TOO_LONG: 'QUALITY.ITEM_TOLERANCE_TOO_LONG',

  // ── O serviço declarado ────────────────────────────────────────────────────
  SERVICE_NOT_FOUND: 'QUALITY.SERVICE_NOT_FOUND',
  SERVICE_NOT_IN_DISCIPLINE: 'QUALITY.SERVICE_NOT_IN_DISCIPLINE',

  // ── A verificação ──────────────────────────────────────────────────────────
  VERIFICATION_REQUIRED: 'QUALITY.VERIFICATION_REQUIRED',
  VERIFICATION_INCOMPLETE: 'QUALITY.VERIFICATION_INCOMPLETE',
  VERIFICATION_UNKNOWN_ITEM: 'QUALITY.VERIFICATION_UNKNOWN_ITEM',
  VERIFICATION_ACTIVITY_NOT_IN_DAY: 'QUALITY.VERIFICATION_ACTIVITY_NOT_IN_DAY',
  VERIFICATION_CHECKLIST_REQUIRED: 'QUALITY.VERIFICATION_CHECKLIST_REQUIRED',
  VERIFICATION_DUPLICATED: 'QUALITY.VERIFICATION_DUPLICATED',
  VERIFICATION_ITEM_HAS_OTHER_NON_CONFORMITY: 'QUALITY.VERIFICATION_ITEM_HAS_OTHER_NON_CONFORMITY',

  // ── A não conformidade ─────────────────────────────────────────────────────
  NON_CONFORMITY_DESCRIPTION_REQUIRED: 'QUALITY.NON_CONFORMITY_DESCRIPTION_REQUIRED',
  NON_CONFORMITY_DESCRIPTION_TOO_LONG: 'QUALITY.NON_CONFORMITY_DESCRIPTION_TOO_LONG',
  NON_CONFORMITY_SOLUTION_REQUIRED: 'QUALITY.NON_CONFORMITY_SOLUTION_REQUIRED',
  NON_CONFORMITY_SOLUTION_TOO_LONG: 'QUALITY.NON_CONFORMITY_SOLUTION_TOO_LONG',
  NON_CONFORMITY_NUMBER_INVALID: 'QUALITY.NON_CONFORMITY_NUMBER_INVALID',
  NON_CONFORMITY_NOT_FOUND: 'QUALITY.NON_CONFORMITY_NOT_FOUND',

  // ── A quantidade não conforme (Fase 37) ────────────────────────────────────
  NON_CONFORMITY_QUANTITY_INVALID: 'QUALITY.NON_CONFORMITY_QUANTITY_INVALID',
  NON_CONFORMITY_QUANTITY_WITHOUT_MEASUREMENT:
    'QUALITY.NON_CONFORMITY_QUANTITY_WITHOUT_MEASUREMENT',
  NON_CONFORMITY_QUANTITY_ABOVE_MEASURED: 'QUALITY.NON_CONFORMITY_QUANTITY_ABOVE_MEASURED',
  NON_CONFORMITY_QUANTITY_KEEPS_MEASUREMENT: 'QUALITY.NON_CONFORMITY_QUANTITY_KEEPS_MEASUREMENT',

  // ── A aba Não conformidades (Fase 37, etapa 2) ─────────────────────────────
  NON_CONFORMITY_NOT_OPEN: 'QUALITY.NON_CONFORMITY_NOT_OPEN',
  NON_CONFORMITY_CANCEL_REASON_REQUIRED: 'QUALITY.NON_CONFORMITY_CANCEL_REASON_REQUIRED',
  NON_CONFORMITY_CANCEL_REASON_TOO_LONG: 'QUALITY.NON_CONFORMITY_CANCEL_REASON_TOO_LONG',
  NON_CONFORMITY_VERSION_CONFLICT: 'QUALITY.NON_CONFORMITY_VERSION_CONFLICT',

  // ── O cômodo e a peça da NC (Fase 37, etapa 3) ─────────────────────────────
  NON_CONFORMITY_PLACE_NOT_OF_DAY: 'QUALITY.NON_CONFORMITY_PLACE_NOT_OF_DAY',
} as const;

export const QUALITY_ERROR_MESSAGE: Readonly<Record<string, string>> = {
  [QUALITY_ERROR.CHECKLIST_NOT_FOUND]: 'Checklist não encontrada.',
  [QUALITY_ERROR.CHECKLIST_INACTIVE]:
    'Esta checklist está desativada e não pode ser respondida. Reative-a em Configurações → Checklists.',
  [QUALITY_ERROR.CHECKLIST_NAME_REQUIRED]: 'O nome da checklist é obrigatório.',
  [QUALITY_ERROR.CHECKLIST_NAME_TOO_LONG]: 'O nome da checklist é longo demais.',
  [QUALITY_ERROR.CHECKLIST_NAME_TAKEN]: 'Já existe uma checklist com este nome.',
  [QUALITY_ERROR.CHECKLIST_WITHOUT_ITEMS]:
    'A checklist precisa de ao menos um item de verificação com rótulo.',
  [QUALITY_ERROR.CHECKLIST_TOO_MANY_ITEMS]: 'A checklist tem itens demais.',
  [QUALITY_ERROR.CHECKLIST_TOO_MANY_SERVICES]: 'A checklist aponta para serviços demais.',
  [QUALITY_ERROR.CHECKLIST_SAMPLING_INVALID]:
    'A amostragem é uma porcentagem inteira entre 1 e 100.',
  [QUALITY_ERROR.ITEM_LABEL_TOO_LONG]: 'O rótulo do item de verificação é longo demais.',
  [QUALITY_ERROR.ITEM_METHOD_TOO_LONG]: 'O método de verificação é longo demais.',
  [QUALITY_ERROR.ITEM_TOLERANCE_TOO_LONG]: 'A tolerância é longa demais.',

  [QUALITY_ERROR.SERVICE_NOT_FOUND]: 'Serviço não encontrado.',
  [QUALITY_ERROR.SERVICE_NOT_IN_DISCIPLINE]:
    'O serviço declarado não é da disciplina desta frente.',

  [QUALITY_ERROR.VERIFICATION_REQUIRED]:
    'Esta frente tem serviço com checklist de qualidade. Declare o serviço executado e responda a checklist antes de gravar a quantidade.',
  [QUALITY_ERROR.VERIFICATION_INCOMPLETE]:
    'Toda checklist respondida precisa de resposta em todos os itens: Aprovado, Reprovado ou Não se aplica.',
  [QUALITY_ERROR.VERIFICATION_UNKNOWN_ITEM]:
    'A resposta aponta para um item que a checklist não tem. Recarregue a tela.',
  [QUALITY_ERROR.VERIFICATION_ACTIVITY_NOT_IN_DAY]:
    'A frente verificada não é desta pessoa neste dia.',
  [QUALITY_ERROR.VERIFICATION_CHECKLIST_REQUIRED]:
    'Este serviço tem checklist de qualidade: responda ao menos uma antes de gravar.',
  [QUALITY_ERROR.VERIFICATION_DUPLICATED]:
    'A mesma frente e o mesmo serviço aparecem duas vezes na verificação.',
  [QUALITY_ERROR.VERIFICATION_ITEM_HAS_OTHER_NON_CONFORMITY]:
    'Este item tem não conformidade aberta por outra medição hoje, e continua reprovado. Abra a sua ali, se encontrou algo, ou deixe como está.',

  [QUALITY_ERROR.NON_CONFORMITY_DESCRIPTION_REQUIRED]:
    'Item reprovado exige a descrição do que foi encontrado (ao menos 3 caracteres).',
  [QUALITY_ERROR.NON_CONFORMITY_DESCRIPTION_TOO_LONG]:
    'A descrição da não conformidade é longa demais.',
  [QUALITY_ERROR.NON_CONFORMITY_SOLUTION_REQUIRED]:
    'Item reprovado exige a solução aplicada: o que foi feito para corrigir (ao menos 3 caracteres).',
  [QUALITY_ERROR.NON_CONFORMITY_SOLUTION_TOO_LONG]: 'A solução aplicada é longa demais.',
  [QUALITY_ERROR.NON_CONFORMITY_NUMBER_INVALID]:
    'O número da não conformidade precisa ser inteiro e maior que zero.',
  [QUALITY_ERROR.NON_CONFORMITY_NOT_FOUND]: 'Não conformidade não encontrada.',

  [QUALITY_ERROR.NON_CONFORMITY_QUANTITY_INVALID]:
    'A quantidade não conforme precisa ser maior que zero, com as casas da unidade do serviço.',
  [QUALITY_ERROR.NON_CONFORMITY_QUANTITY_WITHOUT_MEASUREMENT]:
    'Meça a quantidade executada antes de dizer quanto dela não está conforme.',
  [QUALITY_ERROR.NON_CONFORMITY_QUANTITY_ABOVE_MEASURED]:
    'A quantidade não conforme passa da quantidade medida. Ela é uma parte do que foi medido.',
  [QUALITY_ERROR.NON_CONFORMITY_QUANTITY_KEEPS_MEASUREMENT]:
    'Esta medição tem não conformidade com quantidade, e não pode ser tirada. Desfaça a não conformidade antes.',

  [QUALITY_ERROR.NON_CONFORMITY_NOT_OPEN]:
    'Só a não conformidade aberta se encerra ou se cancela. Esta já foi resolvida ou cancelada.',
  [QUALITY_ERROR.NON_CONFORMITY_CANCEL_REASON_REQUIRED]:
    'Diga por que a não conformidade está sendo cancelada (ao menos 3 caracteres).',
  [QUALITY_ERROR.NON_CONFORMITY_CANCEL_REASON_TOO_LONG]: 'O motivo do cancelamento é longo demais.',
  [QUALITY_ERROR.NON_CONFORMITY_VERSION_CONFLICT]:
    'Outra pessoa mexeu nesta não conformidade enquanto você escrevia. Ela foi recarregada: confira e tente de novo.',

  [QUALITY_ERROR.NON_CONFORMITY_PLACE_NOT_OF_DAY]:
    'A não conformidade só aponta a peça executada e o cômodo com avanço apontado naquele dia, nesta frente e neste serviço.',
};
